"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIScrollingColumns;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIScrollingColumn = _interopRequireDefault(require("../layout/UIScrollingColumn"));

var COLUMN_OPTIONS = ['both', 'left', 'right'];

function UIScrollingColumns(props) {
  var className = props.className,
      leftColumnContent = props.leftColumnContent,
      leftColumnHeader = props.leftColumnHeader,
      leftColumnFooter = props.leftColumnFooter,
      leftColumnMinWidth = props.leftColumnMinWidth,
      leftColumnScrollDirection = props.leftColumnScrollDirection,
      maxHeight = props.maxHeight,
      rightColumnContent = props.rightColumnContent,
      rightColumnFooter = props.rightColumnFooter,
      rightColumnHeader = props.rightColumnHeader,
      rightColumnScrollDirection = props.rightColumnScrollDirection,
      rightColumnWidth = props.rightColumnWidth,
      scrollColumn = props.scrollColumn,
      style = props.style,
      _leftColumnClassName = props._leftColumnClassName,
      _leftColumnFooterClassName = props._leftColumnFooterClassName,
      _leftColumnHeaderClassName = props._leftColumnHeaderClassName,
      _rightColumnClassName = props._rightColumnClassName,
      _rightColumnFooterClassName = props._rightColumnFooterClassName,
      _rightColumnHeaderClassName = props._rightColumnHeaderClassName,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "leftColumnContent", "leftColumnHeader", "leftColumnFooter", "leftColumnMinWidth", "leftColumnScrollDirection", "maxHeight", "rightColumnContent", "rightColumnFooter", "rightColumnHeader", "rightColumnScrollDirection", "rightColumnWidth", "scrollColumn", "style", "_leftColumnClassName", "_leftColumnFooterClassName", "_leftColumnHeaderClassName", "_rightColumnClassName", "_rightColumnFooterClassName", "_rightColumnHeaderClassName"]);
  return _react.default.createElement("div", Object.assign({}, rest, {
    className: (0, _classnames.default)('private-scroll-columns', className, {
      // eslint-disable-next-line eqeqeq
      'private-scroll-columns--custom-height': maxHeight != undefined,
      'private-scroll-columns--grow': scrollColumn !== 'both'
    }),
    style: Object.assign({}, style, {
      maxHeight: maxHeight
    })
  }), _react.default.createElement(_UIScrollingColumn.default, {
    className: (0, _classnames.default)('private-scroll-columns--inset', 'private-scroll-columns--left', _leftColumnClassName, {
      'private-scroll-columns__column--overflows': scrollColumn === 'left'
    }),
    flexBasis: leftColumnMinWidth,
    flexGrow: 9999,
    flexShrink: 1,
    footerClassName: _leftColumnFooterClassName,
    footerContent: leftColumnFooter,
    headerClassName: _leftColumnHeaderClassName,
    headerContent: leftColumnHeader,
    maxHeight: maxHeight,
    scrollDirection: leftColumnScrollDirection
  }, leftColumnContent), _react.default.createElement(_UIScrollingColumn.default, {
    className: (0, _classnames.default)('private-scroll-columns--inset', 'private-scroll-columns--right', _rightColumnClassName, {
      'private-scroll-columns__column--overflows': scrollColumn === 'right'
    }),
    flexBasis: rightColumnWidth,
    flexGrow: 1,
    flexShrink: 1,
    footerClassName: _rightColumnFooterClassName,
    footerContent: rightColumnFooter,
    headerClassName: _rightColumnHeaderClassName,
    headerContent: rightColumnHeader,
    maxHeight: maxHeight,
    scrollDirection: rightColumnScrollDirection
  }, rightColumnContent));
}

UIScrollingColumns.propTypes = {
  leftColumnContent: _propTypes.default.node,
  leftColumnFooter: _propTypes.default.node,
  leftColumnHeader: _propTypes.default.node,
  leftColumnMinWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  leftColumnScrollDirection: _UIScrollingColumn.default.propTypes.scrollDirection,
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  rightColumnContent: _propTypes.default.node,
  rightColumnFooter: _propTypes.default.node,
  rightColumnHeader: _propTypes.default.node,
  rightColumnScrollDirection: _UIScrollingColumn.default.propTypes.scrollDirection,
  rightColumnWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  scrollColumn: _propTypes.default.oneOf(COLUMN_OPTIONS).isRequired,
  _leftColumnClassName: _propTypes.default.string,
  _rightColumnClassName: _propTypes.default.string,
  _leftColumnHeaderClassName: _propTypes.default.string,
  _rightColumnHeaderClassName: _propTypes.default.string,
  _leftColumnFooterClassName: _propTypes.default.string,
  _rightColumnFooterClassName: _propTypes.default.string
};
UIScrollingColumns.defaultProps = {
  leftColumnMinWidth: 250,
  rightColumnWidth: '40%',
  scrollColumn: 'both',
  leftColumnScrollDirection: _UIScrollingColumn.default.defaultProps.scrollDirection,
  rightColumnScrollDirection: _UIScrollingColumn.default.defaultProps.scrollDirection
};
UIScrollingColumns.displayName = 'UIScrollingColumns';
module.exports = exports.default;